import { z } from 'zod';

export const DeleteCurationServiceRequestDtoSchema = z.object({
  curationId: z.string(),
});

export type DeleteCurationServiceRequestDto = z.infer<typeof DeleteCurationServiceRequestDtoSchema>;

export const DeleteCurationServiceResponseDtoSchema = z.object({
  success: z.boolean(),
});

export type DeleteCurationServiceResponseDto = z.infer<
  typeof DeleteCurationServiceResponseDtoSchema
>;
